import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { MainContext } from "../../../../main/context/MainContextProvider";
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { PriorityInsight } from "../../types";

export type InsightPrioritarioProps = {
    insight: PriorityInsight | null | undefined;
};

export default function InsightPrioritario({ insight }: InsightPrioritarioProps) {
    const { theme } = useContext(MainContext);

    if (!insight) {
        return null;
    }

    return (
        <Box
            sx={{
                backgroundColor: "rgba(180, 83, 9, 0.15)",
                border: "1px solid rgba(251, 146, 60, 0.4)",
                borderRadius: "8px",
                padding: "16px"
            }}
        >
            <Box sx={{ display: "flex", gap: "12px" }}>
                <Box
                    sx={{
                        backgroundColor: "rgba(251, 146, 60, 0.2)",
                        borderRadius: "8px",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0
                    }}
                >
                    <WarningAmberIcon sx={{ color: "#FB923C", fontSize: 24 }} />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                        <LightbulbIcon sx={{ color: "#FB923C", fontSize: 18 }} />
                        <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#FB923C" }}>
                            Insight Prioritário
                        </Typography>
                    </Box>
                    <Typography sx={{ fontSize: "13px", fontWeight: "600", color: theme.primaryTextColor, marginBottom: "8px", textAlign: "left" }}>
                        A principal causa de perda é {insight.lossCategory.toLowerCase()} {" "}
                        <Typography component="span" sx={{ fontSize: "13px", fontWeight: "400", color: theme.secondaryTextColor }}>
                            ({insight.lossValue.toFixed(1)} MWh, {insight.lossPercentage.toFixed(1)}% do total)
                        </Typography>.
                    </Typography>
                    <Typography sx={{ fontSize: "13px", fontWeight: "400", color: theme.primaryTextColor, lineHeight: "1.5", textAlign: "left" }}>
                        {insight.recommendation}
                        {insight.isAvoidable && insight.avoidablePercentage > 0 && (
                            <>
                                {" "}As perdas gerenciáveis representam{" "}
                                <Typography component="span" sx={{ fontSize: "13px", fontWeight: "600", color: theme.primaryTextColor }}>
                                    {insight.avoidablePercentage.toFixed(1)}%
                                </Typography>
                                {" "}do total. Reduzir as perdas gerenciáveis em 50% pode recuperar até{" "}
                                <Typography component="span" sx={{ fontSize: "13px", fontWeight: "600", color: "#10B981" }}>
                                    {insight.potentialRecovery.toFixed(1)} MWh
                                </Typography>
                                {" "}de energia.
                            </>
                        )}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
